import { render } from "./WCSideMenuItem.vue?vue&type=template&id=616291a2&scoped=true"
import script from "./WCSideMenuItem.vue?vue&type=script&lang=js"
export * from "./WCSideMenuItem.vue?vue&type=script&lang=js"

import "./WCSideMenuItem.vue?vue&type=style&index=0&id=616291a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616291a2"]])

export default __exports__